export const apiRoutes = {
  place: {
    autocomplete: '/dplaces/web/v4/autocomplete',
    detail: 'gplaces/web/v2/detail',
    geocode_reverse: '/wgeo/v2/reverse',
    geocode: 'wgeo/geocode',
  },
  auth: {
    link_account: '/api/v3/private/food-order/link-ahamove-account',
    activate: '/api/v3/public/user/activate',
    register: '/api/v3/public/user/register',
    verifyOtp: '/api/v3/public/user/verify_otp',
  },
  ahafood: {
    web_view: {
      add_rating_image: (orderId: string) =>
        `/api/v3/private/food-order/customer/ratings/${orderId}/images`,
      delete_rating_image: (orderId: string) =>
        `/api/v3/private/food-order/customer/ratings/${orderId}/images`,
      add_rating: (orderId: string) =>
        `/api/v3/private/food-order/customer/ratings/${orderId}`,
      delete_rating: (orderId: string) =>
        `/api/v3/private/food-order/customer/ratings/${orderId}`,
      add_comment: (orderId: string) =>
        `/api/v3/private/food-order/customer/ratings/${orderId}/comment`,
      // v4 *-ahm endpoints — verify Ahamove token (Bearer cookie `token`).
      // Replace v3 customer endpoints sau khi migrate auth sang ahamove-token-only.
      create_order_ws: '/api/v4/private/food-order/customer/orders/create-ahm',
      estimate_total_ws:
        '/api/v4/private/food-order/customer/orders/estimate-ahm',
      estimate_ws: '/api/v3/private/food-order/customer/estimate/item',
      save_session: '/api/v3/private/food-order/webview',
      login: '/api/v3/public/food-order/webview/login',
      customization: '/api/v3/private/food-order/webview/customization',
      get_session: '/api/v3/public/food-order/webview',
      get_store_order: '/api/v3/private/food-order/webview/store',
      get_menu_order: '/api/v3/private/food-order/webview/menu',
      estimate_item: '/api/v3/private/food-order/webview/estimate/item',
      estimate: '/api/v3/private/food-order/webview/estimate',
      get_all_promo: '/api/v3/private/food-order/webview/promo',
      create_order: '/api/v3/private/food-order/webview/order',
      get_deal_progress: '/api/v3/public/food-order/promo/progress',
      get_flash_deals: '/api/v4/public/food-order/promos/flash-deals',
      trending_items: '/api/v4/public/food-order/items/trending',
    },
    store: {
      get_solomeal_item: '/api/v3/public/food-order/item/solo-meal',
      get_rating: `/api/v3/private/food-order/customer/ratings`,
      get_search_autocomplete: '/api/v3/public/food-order/store/autocomplete',
      get_personalize: '/api/v1/personalize/for-you',
      chatbot_suggest_questions: '/api/v1/personalize/suggest_question',
      chatbot_interacted:
        '/api/v3/private/food-order/customer/chatbot-interacted',
      get_all_promo_ws: (store_id: string) =>
        `/api/v3/public/food-order/promo/${store_id}`,
      get_order_customization: '/api/v3/public/food-order/customization',
      request_otp: '/api/v3/public/food-order/customer/request-phone-login-otp',
      login_otp: '/api/v3/public/food-order/customer/phone-login',
      add_new_address: '/api/v3/private/food-order/customer/address',
      login_fb: 'api/v3/public/food-order/customer/login',
      ahamove_login: 'api/v3/public/food-order/customer/ahamove-login',
      store_menu_images: (store_id: number) =>
        `api/v3/public/food-order/store/${store_id}/menu-images`,
      store_items: (store_id: number) =>
        `api/v3/private/food-order/item/${store_id}`,
      store_info: (store_id: number) =>
        `api/v3/private/food-order/store/${store_id}`,
      get_promo: (store_id: number) =>
        `api/v3/private/food-order/promo/store/${store_id}`,
      update_status_promo: (promo_code: string) =>
        `api/v3/private/food-order/promo/${promo_code}/activation`,
      update_promo: (promo_code: string) =>
        `api/v3/private/food-order/promo/${promo_code}`,
      create_promo: `/api/v3/private/food-order/promo`,
      get_deal: `api/v3/public/food-order/tag`,
      // AF-062 — hệ banner mới, gộp Strapi hero + /tag super-deal (thay get_deal)
      get_campaign_banners: `/api/v4/public/food-order/campaign-banners`,
      get_store_by_slug: (slug: string) =>
        `/api/v3/public/food-order/store/${slug}`,
      get_store: `api/v3/public/food-order/store`,
      get_category: `/api/v3/public/food-order/category`,
      get_item_type: `/api/v3/public/food-order/item_type`,
      get_item_by_type: (type: number) =>
        `/api/v3/public/food-order/item/item_type/${type}`,
      get_menu_items: (store_id: number) =>
        `/api/v3/public/food-order/store/${store_id}/menu-item`,
      get_order_history: '/api/v3/private/food-order/customer/order',
      get_order_detail: (order_code: string) =>
        `/api/v3/private/food-order/customer/order/${order_code}`,
      cancel_order: (order_id: string) =>
        `/api/v4/private/food-order/customer/orders/${order_id}/cancel-ahm`,
      submit_rating: (order_code: string) =>
        `/api/v3/private/food-order/customer/order/${order_code}/rating`,
      get_campaign: `/api/v3/public/food-order/promo/campaign`,
    },
    update_page: (pageId: string) =>
      `/api/v3/private/food-order/page/${pageId}`,
    get_page: `/api/v3/private/food-order/page`,
    get_info: 'api/v3/private/food-order/self',
    fb_login: 'api/v3/public/food-order/social-login',
    create_store: 'api/v3/private/food-order/store',
    acquire_merchant: '/web/v1/public/ahmsites/form/acquire-merchant',
    append_page: (pageId: string) => `/v3/internal/page/facebook/${pageId}`,
  },
  cms: {
    homeBanner: {
      list: '/api/home-banner?populate[items][populate]=%2A',
    },
  },
};
